import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_UNIT_MANUFACTURERS',
	'CREATE_UNIT_MANUFACTURERS',
	'UPDATE_UNIT_MANUFACTURERS',
	'DELETE_UNIT_MANUFACTURERS',
);
